import { render, staticRenderFns } from "./BipBip.vue?vue&type=template&id=02c77fb0&scoped=true"
import script from "./BipBip.vue?vue&type=script&lang=js"
export * from "./BipBip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c77fb0",
  null
  
)

export default component.exports